import React, { useEffect } from "react"
import { connect } from "react-redux"
import { generateBizminerRatios } from "../../../../store/modules/financialRatios/actions";
import YearBar from "../BizminerRatios/YearBar";
import Item from "../BizminerRatios/Item";

function VeticalIQRatios({
  dispatchGenerateBizminerRatios,
}) {
  // Mounted
  useEffect(() => {
    handleGenerateBizminerRatios()
  }, [])

  // Methods
  const handleGenerateBizminerRatios = async () => {
    await dispatchGenerateBizminerRatios()
  }

  return (
    <div>

      <YearBar />

      <Item label = "Current Ratio" tooltip = "Current Assets / Current Liabilities" />
      <Item label = "Quick Ratio" tooltip = "( Cash + Marketable Securities + Accounts Receivable ) / Current Liabilities" />
      <Item label = "Days Inventory" tooltip = "( Inventory / Cost of Sales ) × 365" />
      <Item label = "Days Receivables" tooltip = "( Accounts Receivable / Business Revenue ) × 365" />
      <Item label = "Days Payable" tooltip = "( Accounts Payable / Cost of Sales ) × 365" />
      <Item label = "Pre-Tax Return On Assets" tooltip = "Pre-Tax Net Profit / Total Assets" percent = {true} />
      <Item label = "Pre-Tax Return on Net Worth" tooltip = "Pre-Tax Net Profit / Total Equity" percent = {true} />
      <Item label = "Pre-Tax Return on Business Revenue" tooltip = "Pre-Tax Net Profit / Business Revenue" percent = {true} />
      <Item label = "Interest Coverage" tooltip = "EBITDA / Interest Expense" />
      <Item label = "Current Liabilities : Net Worth" tooltip = "Current Liabilities / Total Equity" percent = {true} />
      <Item label = "Long-Term Liabilities : Net Worth" tooltip = "Long-Term Liabilities / Total Equity" percent = {true} />
      <Item label = "Total Liabilities : Net Worth" tooltip = "Total Liabilities / Total Equity" percent = {true} />
      
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateBizminerRatios() {
    await dispatch(generateBizminerRatios())
  },
})

export default connect(null, mapDispatchToProps)(VeticalIQRatios)
